import { useState, useEffect } from 'react';
import { IAddCartInstance } from '@base/product/useAddCart';
import { getProductAddOns } from '@base/product/services';
import { IProduct } from 'base/interfaces/product';

export type IAddOnsInstance = {
    variantAddOns: IProduct[];
    checkedAddOns: IAddCartInstance['checkedAddOns'];
    onChangeCheckedAddOns: IAddCartInstance['onChangeCheckedAddOns'];
};

type IAddOnsProps = {
    addCart: IAddCartInstance;
};

export default function useAddOns({ addCart }: IAddOnsProps): IAddOnsInstance {
    const {
        shownVariant: {
            productId,
            variantId
        },
        checkedAddOns,
        onChangeCheckedAddOns
    } = addCart;

    const [variantMap, setVariantMap] = useState<Record<string, IProduct[]>>({});

    const variantAddOns = variantMap[variantId] || [];

    useEffect(() => {
        getProductAddOns({
            productId,
            variantId,
        }).then(res => {
            setVariantMap(res);
        })
    }, []);

    return {
        variantAddOns,
        checkedAddOns,
        onChangeCheckedAddOns
    }
}